import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';

class EventLog extends Component {

  componentDidUpdate(){
    document.getElementById('eventLog').scrollTo(0, document.getElementById('eventLog').scrollHeight);
  }

  render() {
    let {eventLog} = this.props.context;

    return (
      <div id="eventLog">
        {
          eventLog.map((x,index)=>{
            return (
              <p key={index} className={x.type}>{x.message}</p>
            )
          })
        }    
      </div>
    );
  }
}

export default withContext(EventLog);